export const StepIndicator = ({ count, activeIndex, onSelect }) => {
  const stateCls = (index) => {
    if (index === activeIndex) return 'active';
    return index < activeIndex ? 'done' : '';
  };

  return (
    <div className="stepper-chips">
      {Array.from({ length: count }, (_, index) => (
        <button
          key={index}
          type="button"
          className={`stepper-chip ${stateCls(index)}`}
          aria-label={`Шаг ${index + 1}`}
          aria-current={index === activeIndex}
          onClick={() => onSelect(index)}
        >
          {index + 1}
        </button>
      ))}

      <span className="stepper-caption">
        Шаг {activeIndex + 1} из {count}
      </span>
    </div>
  );
};
